import React from 'react';

const TutorialVideosIcon = () => (
  <svg
    id="CC_NG_Tutorial_Videos_icon"
    data-name="CC NG Tutorial Videos icon"
    xmlns="http://www.w3.org/2000/svg"
    width="103.546"
    height="92"
    viewBox="0 0 103.546 92"
  >
    <path
      id="Path_2215"
      data-name="Path 2215"
      d="M76.757,78.944l-4.693,1.1a27.447,27.447,0,0,1-30.225,7.091l-4.688,1.1a30.383,30.383,0,0,0,39.606-9.292"
      fill="#b95700"
    />
    <path
      id="Path_2216"
      data-name="Path 2216"
      d="M100.546,69.33H81.259a30.477,30.477,0,0,0-.289-16.7h9.237a1.5,1.5,0,0,0,.624-2.861L77.86,52.815a27.351,27.351,0,0,1-5.8,27.23l4.693-1.1a30.421,30.421,0,0,0,3.531-6.614h21.758a1.5,1.5,0,0,0,1.5-1.5V46.789l-3,.7Z"
      fill="#eb6909"
    />
    <path
      id="Path_2217"
      data-name="Path 2217"
      d="M24.535,65.325l-2.923.686a30.571,30.571,0,0,0,.676,3.319H7.464L.025,71.075A1.5,1.5,0,0,0,1.5,72.33H23.259A30.686,30.686,0,0,0,37.151,88.236l4.688-1.1a27.584,27.584,0,0,1-17.3-21.811"
      fill="#eb6909"
    />
    <path
      id="Path_2218"
      data-name="Path 2218"
      d="M43.871,75.175a1.5,1.5,0,0,0,1.5,0L66.828,62.787a1.5,1.5,0,0,0,0-2.6l-5.9-3.4-4.265,1,6.41,3.7L46.121,71.279V60.261l-3,.7V73.876a1.5,1.5,0,0,0,.75,1.3"
      fill="#eb6909"
    />
    <path
      id="Path_2219"
      data-name="Path 2219"
      d="M51.7,33.978c.024,0,.046.007.07.007s.046-.006.069-.007A27.552,27.552,0,0,1,77.308,51.264a1.474,1.474,0,0,0,.311.789c.091.249.157.509.241.762l12.971-3.043a1.493,1.493,0,0,0-.624-.139H79.888a30.633,30.633,0,0,0-7.24-10.369H90.207a1.5,1.5,0,0,0,0-3H68.92a30.375,30.375,0,0,0-10.977-4.647l-32.6,7.647H30.9a30.619,30.619,0,0,0-7.24,10.369H13.375a1.5,1.5,0,1,0,0,3h9.2a30.1,30.1,0,0,0-.965,13.378l2.923-.686A27.483,27.483,0,0,1,51.7,33.978"
      fill="#5f9501"
    />
    <path
      id="Path_2220"
      data-name="Path 2220"
      d="M90.207,25.9a1.5,1.5,0,0,0,1.5-1.5,1.48,1.48,0,0,0-.161-.662L82.328,25.9Z"
      fill="#5f9501"
    />
    <path
      id="Path_2221"
      data-name="Path 2221"
      d="M100.546,47.493l3-.7V20.919l-3,.7Z"
      fill="#5f9501"
    />
    <path
      id="Path_2222"
      data-name="Path 2222"
      d="M46.121,51.7l10.547,6.09,4.266-1L45.371,47.8a1.5,1.5,0,0,0-2.25,1.3V60.965l3-.7Z"
      fill="#5f9501"
    />
    <path
      id="Path_2223"
      data-name="Path 2223"
      d="M3,69.33V44.507l-3,.7V70.83a1.413,1.413,0,0,0,.025.245L7.464,69.33Z"
      fill="#5f9501"
    />
    <path
      id="Path_2224"
      data-name="Path 2224"
      d="M50.273,31.015A30.32,30.32,0,0,0,34.6,36.286a1.356,1.356,0,0,0-.2-.021H13.375a1.5,1.5,0,0,0,0,3h11.97l32.6-7.647a30.273,30.273,0,0,0-4.669-.6V9.76a6.705,6.705,0,0,1,.757-3.1l-4.107.963a6.72,6.72,0,0,1,.35,2.132Z"
      fill="#79b61d"
    />
    <path
      id="Path_2225"
      data-name="Path 2225"
      d="M62.112,24.4a1.5,1.5,0,0,0,1.5,1.5H82.328l9.218-2.162a1.5,1.5,0,0,0-1.339-.838h-26.6a1.5,1.5,0,0,0-1.5,1.5"
      fill="#79b61d"
    />
    <path id="Path_2226" data-name="Path 2226" d="M3,18.636l-3,.7V45.21l3-.7Z" fill="#79b61d" />
    <path
      id="Path_2227"
      data-name="Path 2227"
      d="M100.546,3V21.623l3-.7V1.5a1.5,1.5,0,0,0-1.5-1.5H82.439L69.651,3Z"
      fill="#79b61d"
    />
    <path
      id="Path_2228"
      data-name="Path 2228"
      d="M39.97,22.9h-26.6a1.5,1.5,0,1,0,0,3h26.6a1.5,1.5,0,0,0,0-3"
      fill="#79b61d"
    />
    <path
      id="Path_2229"
      data-name="Path 2229"
      d="M3,3H43.514a6.768,6.768,0,0,1,6.41,4.628l4.106-.963a6.762,6.762,0,0,1,6-3.665h9.618L82.438,0H60.033a9.753,9.753,0,0,0-8.26,4.584A9.752,9.752,0,0,0,43.514,0H1.5A1.5,1.5,0,0,0,0,1.5V19.34l3-.7Z"
      fill="#c8d200"
    />
  </svg>
);

export default TutorialVideosIcon;
